import React, { useEffect, useState } from 'react';
import Formulario from './GastoProyectoForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

function GastoProyecto(props) {
    const { loader, periodoD, modulo, datos,
        listarProyectos, detalleProducto,
        detalleOrden, registroGasto, agregarLinea, detalleOrd,
        eliminarLineaProductoNuevo, listarGastos, agregarLineaNueva,
        modificarGasto, eliminarLineaGasto
    } = props;        
        
    useEffect(() => {
        const { match, leer, getModulo, leerPeriodoD, 
            parametrosEmpresa, limpiarOrden } = props;
        const id = match.params.id;
        if (id) {
            setCrear(false);
            leer(id);
        }
        let ruta = window.location.href;
        let periodo = ruta.split('/');
        leerPeriodoD(periodo[5], periodo[7]);
        getModulo(periodo[5], periodo[4]);
        parametrosEmpresa();
        limpiarOrden();
    }, [])

    const [crear, setCrear] = useState(true);

    const editar = window.location.href.includes('editar');
    let titulo = 'Crear gastos de proyecto';
    let disabled = false;
    if (crear === false && editar === false) {
        disabled = true;
        titulo = 'Ver gastos de proyecto';
    }

    return (
        <LoadMask loading={loader} dark>
            <Formulario
                registroGasto = {registroGasto}
                modificarGasto = {modificarGasto}
                datos = {datos}
                crear = {crear}
                titulo = {titulo}
                editar = {editar}
                periodoD = {periodoD}
                modulo = {modulo}
                bloqueo = {disabled}
                listarProyectos = {listarProyectos}
                detalleProducto = {detalleProducto}
                detalleOrden = {detalleOrden}
                agregarLinea = {agregarLinea}
                detalleOrd = {detalleOrd}
                eliminarLineaProductoNuevo = {eliminarLineaProductoNuevo}
                listarGastos = {listarGastos}
                agregarLineaNueva = {agregarLineaNueva}
                eliminarLineaGasto = {eliminarLineaGasto}
            />
        </LoadMask>
    );
}

export default GastoProyecto;